import React, { lazy } from "react";


      const HomePage = lazy(() =>
        import(
          "../../../KPISummaryView/components/HomePage/HomePage"
        )
    );
      const KPISummaryViewV2 = lazy(() =>
        import(
          "../../../KPISummaryViewV2/components/KPISummaryViewV2/KPISummaryViewV2"
        )
    );
      const KPITrendHome = lazy(() =>
        import(
          "../../../KPITrendView/components/KPITrendHome/KPITrendHome"
        )
    );
      const KPTLPlanVsActual = lazy(() =>
        import(
          "../../../KPTLPlanVsActual/components/KPTLPlanVsActual/KPTLPlanVsActual.js"
        )
    );
      const KPITrendV2 = lazy(() =>
        import(
          "../../../KPITrendV2/components/KPITrendV2/KPITrendV2"
        )
    );
      const KPIDistributionV2 = lazy(() =>
        import(
          "../../../KPIDistributionV2/components/KPIDistributionV2/KPIDistributionV2"
        )
    );
      const ErisSalesGrowthComponent = lazy(() =>
        import(
          "../../../ErisSalesGrowthComponent/components/ErisSalesGrowthComponent/ErisSalesGrowthComponent"
        )
    );
      const KPTLWidgets = lazy(() =>
        import(
          "../../../KPTLWidgets/components/KPTLWidgets/KPTLWidgets.js"
        )
    );
      const ErisWidgets = lazy(() =>
        import(
          "../../../../../../client-apps/code/apps/ErisWidgets/components/ErisWidgets/ErisWidgets"
        )
    );
      const HawkeyeKPIOverview = lazy(() =>
        import(
          "../../../HawkeyeKPIOverview/components/HawkeyeKPIOverviewHome/HawkeyeKPIOverviewHome.js"
        )
    );
      const MonitorFirstWidget = lazy(() =>
        import(
          "../../../MonitorFirstWidget/components/MonitorFirstWidget/MonitorFirstWidget"
        )
    );
      const AnalyticsForecastCustomWidget = lazy(() =>
        import(
          "../../../AnalyticsForecastCustomWidget/components/AnalyticsForecastCustomWidget/AnalyticsForecastCustomWidget"
        )
    );
      const COVID19MapWithDistributionUI = lazy(() =>
        import(
          "../../../COVID19MapWithDistribution/components/COVID19MapWithDistributionUI/COVID19MapWithDistributionUI.js"
        )
    );
      const BoxAndWhiskerPlotChart = lazy(() =>
        import(
          "../../../BoxAndWhiskerPlotChart/components/BoxAndWhiskerPlotChart/BoxAndWhiskerPlotChart"
        )
    );
      const PivotWithTrend = lazy(() =>
        import(
          "../../../PivotWithTrend/components/PivotWithTrendUI/PivotWithTrendUI"
        )
    );
      const InsightsPivotApp = lazy(() =>
        import(
          "../../../InsightsPivotApp/components/InsightsPivotApp/InsightsPivotApp"
        )
    );
      const WaterfallChart = lazy(() =>
        import(
          "../../../WaterfallChart/components/WaterfallChartWrapper/WaterfallChartWrapper.js"
        )
    );
      const PriceChangeWithGroupColumnChart = lazy(() =>
        import(
          "../../../PriceChangeWithGroupColumnChart/components/PriceChangeWithGroupColumnChart/PriceChangeWithGroupColumnChart"
        )
    );

function renderWidget(
  widget,
  widgetWidth,
  widgetHeight,
  KPIWiseConfigs,
  viewDetails,
  KPIWiseFilters,
  dashboardDate,
  userDefinedSettings,
  onSaveUserDefinedSettings,
  setWidgetLocalFilters,
  onDownloadData
) {
  switch (widget.widgetName) {
    
      case "KPI_SUMMARY_VIEW": {
        return (
          <HomePage
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "KPI_SUMMARY_VIEW_V2": {
        return (
          <KPISummaryViewV2
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "KPI_TREND_VIEW": {
        return (
          <KPITrendHome
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "KPTL_STACK_BAR_CHART": {
        return (
          <KPTLPlanVsActual
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "KPI_TREND_V2": {
        return (
          <KPITrendV2
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "KPI_DISTRIBUTION_V2": {
        return (
          <KPIDistributionV2
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "ERIS_SALES_GROWTH_COMPONENT": {
        return (
          <ErisSalesGrowthComponent
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "KPTL_WIDGETS": {
        return (
          <KPTLWidgets
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "ERIS_WIDGETS": {
        return (
          <ErisWidgets
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "HAWKEYE_KPI_OVERVIEW": {
        return (
          <HawkeyeKPIOverview
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "MONITOR_FIRST_WIDGET": {
        return (
          <MonitorFirstWidget
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "ANALYTICS_FORECAST_CUSTOM_WIDGET": {
        return (
          <AnalyticsForecastCustomWidget
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "COVID19_MAP_WITH_DISTRIBUTION": {
        return (
          <COVID19MapWithDistributionUI
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "BOX_WHISKER_PLOT_CHART": {
        return (
          <BoxAndWhiskerPlotChart
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "PIVOT_WITH_TREND": {
        return (
          <PivotWithTrend
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "INSIGHTS_PIVOT": {
        return (
          <InsightsPivotApp
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "WATERFALL_CHART": {
        return (
          <WaterfallChart
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
      case "PRICE_CHANGE_WITH_GROUP_COLUMN_CHART": {
        return (
          <PriceChangeWithGroupColumnChart
            width={widgetWidth}
            height={widgetHeight}
            KPIWiseConfigs={KPIWiseConfigs}
            viewDetails={viewDetails}
            KPIWiseFilters={KPIWiseFilters}
            dashboardDate={dashboardDate}
            gridGap={10}
            appName={widget.appName}
            appID={widget.appID}
            componentID={widget.componentID}
            {...widget.widgetSettings}
            userDefinedSettings={userDefinedSettings}
            onSaveUserDefinedSettings={onSaveUserDefinedSettings}
            onDownloadData={onDownloadData}
            setWidgetLocalFilters={setWidgetLocalFilters}
            subscribeID={widget.subscribeID}
          />
        );
        break;
    }
    case "":
    default: {
      console.warn("Invalid widget name", widget.widgetName);
      return null;
    }
  }
}

export { renderWidget };
